import { render, staticRenderFns } from "./SupportCannedResponse.vue?vue&type=template&id=ab021b10&"
import script from "./SupportCannedResponse.vue?vue&type=script&lang=js&"
export * from "./SupportCannedResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports